<template>
    <div class="card card-settings">
        <div class="card-header card-header-tabs-custom">
            <ul class="nav nav-tabs nav-fill card-header-tabs tabs-rounded">
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: activeTab === 1 }"
                        href="#"
                        @click.prevent="activeTab = 1"
                    >Información personal</a>
                </li>
                <li class="nav-item" v-if="userId && isCurrentUser">
                    <a
                        class="nav-link"
                        :class="{ active: activeTab === 2 }"
                        href="#"
                        @click.prevent="activeTab = 2"
                    >Recibos de nómina</a>
                </li>
                <li class="nav-item" v-if="userId">
                    <a
                        class="nav-link"
                        :class="{ active: activeTab === 3 }"
                        href="#"
                        @click.prevent="activeTab = 3"
                    >Cuentas</a>
                </li>
                <li class="nav-item" v-if="userId" v-can="'sensitive_data'">
                    <a
                        class="nav-link"
                        :class="{ active: activeTab === 4 }"
                        href="#"
                        @click.prevent="activeTab = 4"
                    >Datos sensibles</a>
                </li>
                <li class="nav-item" v-if="userId && isCurrentUser">
                    <a
                        class="nav-link"
                        :class="{ active: activeTab === 5 }"
                        href="#"
                        @click.prevent="activeTab = 5"
                    >Historial de asistencia</a>
                </li>
                <li class="nav-item" v-if="userId" v-can="'user_documents'">
                    <a
                        class="nav-link"
                        :class="{ active: activeTab === 6 }"
                        href="#"
                        @click.prevent="activeTab = 6"
                    >Archivo</a>
                </li>
            </ul>
        </div>
        <div class="card-body">
            <!-- Pass userId from route params. If creating new user, userId is undefined/null -->
            <profile v-if="activeTab === 1" :userId="userId"/>
            <payroll-receipts-table v-if="activeTab === 2 && userId && isCurrentUser" :userId="userId" />
            <user-accounts-table v-if="activeTab === 3 && userId" :userId="userId" />
            <sensitive-data-tab v-if="activeTab === 4 && userId" :userId="userId" :canEdit="canEdit" />
            <attendance-history-tab v-if="activeTab === 5 && userId && isCurrentUser" :userId="userId" />
            <user-documents-tab v-if="activeTab === 6 && userId" :userId="userId" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Profile from '@/pages/users/profile';
import UserAccountsTable from '@/pages/users/UserAccountsTable';
import PayrollReceiptsTable from '@/pages/users/PayrollReceiptsTable';
import SensitiveDataTab from '@/pages/users/SensitiveDataTab';
import AttendanceHistoryTab from '@/pages/users/AttendanceHistoryTab';

import { checkPermission } from '@/helpers/acl';

export default {
    name: 'UserForm',
    components: {
        Profile,
        UserAccountsTable,
        PayrollReceiptsTable,
        SensitiveDataTab,
        AttendanceHistoryTab,
        UserDocumentsTab: () => import('@/pages/users/UserDocumentsTab')
    },
    data() {
        return {
            activeTab: 1
        };
    },
    computed: {
        userId() {
            // If route param id exists, return it. Otherwise null (Create mode)
            return this.$route.params.id ? parseInt(this.$route.params.id) : null;
        },
        ...mapGetters({
            authUser: 'auth/user'
        }),
        isCurrentUser() {
            return this.authUser && this.userId === this.authUser.id;
        },
        canEdit() {
            // Edit permission required AND not editing self
            return checkPermission('edit_users') && !this.isCurrentUser;
        }
    }
};
</script>

<style>
/* Reusing styles from tabs_profile.vue for consistency */
.card-settings {
  border: 0;
  border-radius: 24px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);
  overflow: hidden;
}

.card-header-tabs-custom {
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  padding: 0;
}

.tabs-rounded {
  border-bottom: 0;
}

.tabs-rounded .nav-link {
  border: 0;
  border-bottom: 3px solid transparent;
  border-radius: 0;
  padding: 1rem 1.5rem;
  color: #6b7280;
  font-weight: 500;
  font-size: 0.95rem;
}

.tabs-rounded .nav-link:hover {
  color: #0f766e;
}

.tabs-rounded .nav-link.active {
  color: #0f766e;
  border-bottom-color: #14b8a6;
  background-color: transparent;
}
</style>
